<template>
	<div class="educa_manage_wrap" v-loading="loading">
		<div class="educa_manage_header">
			<h2>班课统计</h2>
			<div class="operation">
				<el-select v-model="searchForm.course" @change="searchList" placeholder="请选择所属课程" clearable filterable>
					<el-option
						v-for="(item,key) in courseList"
						:key="key"
						:label="item.courseName"
						:value="item.id">
					</el-option>
				</el-select>
					<el-select v-model="searchForm.status" @change="searchList" placeholder="请选择班课状态" clearable>
					<el-option
						v-for="(item,key) in statusList"
						:key="key"
						:label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
				<n-search-input v-model="searchForm.class" :placeholder="'请输入班级名称'" @searchInput="searchList()"></n-search-input>
			</div>
		</div>
		<div class="educa_manage_table" :style="'padding-bottom:'+(tableData.length?'0':'16')+'px'">
			<n-table
        ref="statistics_manage"
        :tableData="tableData"
        :tableHeader="StatisticsTableHeader"
        :ISChangeCheckout="false"
        :TableHeight="TableHeight"
        @operation="operation"
      ></n-table>
			<el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageTotal.currentPage"
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageTotal.pageSize"
        :pager-count="5"
        layout="sizes, prev, pager, next"
        :total="pageTotal.total"
        class="paginator"
        v-if="tableData.length"
      ></el-pagination>
		</div>
	</div>
</template>
<script>
  import * as api from "@/api/HNstatisticsApi"
	import { StatisticsTableHeader } from "../../../global/table_header_data";
	export default {
		data() {
			var checkIdCard = (rule, value, callback) => {
				if(!value) {
					return callback(new Error('请输入身份证号'));
				}
				if(value.length < 18) {
					callback(new Error('身份证号必须满足18位'));
				} else {
					callback();
				}
			};
			return {
        loading: true,
        windowHeight: window.innerHeight,
        searchForm: {
          course: '',
          status: '',
          class: ''
        },
        courseList: [],
        statusList: [
          {name: '未开始', id: 0},
          {name: '进行中', id: 1},
          {name: '已结束', id: 2},
        ],
        tableData: [],
        empty: '暂无数据',
        pageTotal: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        deptId: sessionStorage.getItem('deptId'),
				StatisticsTableHeader: StatisticsTableHeader,
      	TableHeight: "0px",
			}
    },
		created() {
      this.getAllCourse()
      this.searchList()
    },
    methods: {
			//获取所有课程
      getAllCourse(){
        api.getAllCourse(this.deptId).then(rs=>{
          if(rs.code==0){
            this.courseList = rs.data
          }else{
						this.$messageError(rs.msg)
					}
        })
      },
			// 获取班课统计列表
      getClassInfoList(){
				let that = this
        this.loading = true
        api.getClassInfoList({
          "className": this.searchForm.class,
          "courseId": this.searchForm.course,
          "deptId": this.deptId,
          "status": this.searchForm.status,
          "page": this.pageTotal.currentPage,
          "limit": this.pageTotal.pageSize
        }).then(rs=>{
          if(rs.code==0){
						that.tableData = []
						that.TableHeight = "300px"
						let listArr = rs.data
						if(listArr.list.length>0){
							listArr.list.forEach((v,i)=>{
								let obj = v
								let num = (listArr.pageNum-1) * listArr.pageSize + i+1
								let timeStr = ""
								let statusStr = ""
								timeStr = v.startDate.slice(0,10)
								if(v.status==0){
									statusStr = '未开始'
								}else if(v.status==1){
									statusStr = '进行中'
								}else if(v.status==2){
									statusStr = '已结束'
								}else{
									statusStr = "--";
								}
								that.$set(obj, 'timeStr', timeStr)
								that.$set(obj, 'statusStr', statusStr)
								that.$set(obj, 'num', num)
								that.tableData.push(obj)
							})
							this.pageTotal.total = listArr.total;
							// this.TableHeight = this.tableData.length * 40 + 41 + 'px';
							this.TableHeight = (that.windowHeight - 200) + 'px';
						}
            this.loading = false
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
			searchList(){// 查询
        this.getClassInfoList()
      },
			// 学员
      studentSearch(row){
				let path = ""
				if(this.$route.path.split('/')[1] == 'n-educa'){
					path = '/n-educa/classStatistics/studentList'
				}else{
					path = '/educa/classStatistics/studentList'
				}
        this.$router.push({
          path: path,
          query: {
            classId: row.classId,
      			courseId: row.courseId,
      			className: row.className,
      			index: 'first',
          }
        })
      },
			// 统计
      statisticsJump(row){
        sessionStorage.setItem('isPreview', false)
        sessionStorage.setItem('courseType', row.classType)
        sessionStorage.setItem('subjectId', row.subjectId)
        let path = ''
        if(row.classType==1){
          path = '/statisticsPage/theory'
        }else if(row.classType==2){
          path = '/statisticsPage/training'
        }else{
          path = '/statisticsPage/comprehensive'
        }
        const { href } = this.$router.resolve({
          path: path,
          query: {
            id: row.courseId,
            classId: row.classId,
            className: row.name,
            courseName: row.courseName,
          }
        });
        window.open(href, '_blank');
      },
			// table-操作
			operation(type, RowData) {
				if(type=='student'){
					this.studentSearch(RowData)
				}else if(type=='statistics'){
					this.statisticsJump(RowData)
				}
			},
			handleCurrentChange(val) {//分页
				this.loading = true;
	      this.pageTotal.currentPage = val;
	      this.searchList()
	   	},
	   	handleSizeChange(val){//分页
				this.loading = true;
	   		this.pageTotal.pageSize = val;
	   		this.pageTotal.currentPage = 1;
	      this.searchList()
      },
    }
	}
</script>

<style lang="scss" scoped>
	.class_statistics_wrap {
		padding: 0 16px;
    background: #fff;
    margin: 16px 16px 0;
    border-radius: 4px;
		.class_statistics_header {
			height: 48px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid #5397f7;
			h2 {
				border-left: 2px solid #5397f7;
				color: #5397f7;
				font-size: 14px;
				padding-left: 4px;
				line-height: 10px;
			}
			.btn {
				display: flex;
				align-items: center;
				.el-button {
					min-width: 72px;
					padding: 7px 11px;
					border-color: #5397F7;
					color: #5397F7;
					font-size: 12px;
					&:hover {
						background: #5397F7;
						color: #fff;
					}
				}
				.el-select {
					width: 160px;
					margin-right: 10px;
					/deep/ .el-input__inner {
						height: 30px;
						line-height: 30px;
					}
					/deep/ .el-input__icon {
						line-height: 30px;
					}
				}
				.el-input {
					width: 220px;
					margin-right: 10px;
					/deep/ .el-input__inner {
						height: 30px;
						line-height: 30px;
					}
					/deep/ .el-input__suffix {
						right: 0;
					}
					/deep/ .el-input__icon {
						width: 40px;
						line-height: 30px;
						color: #fff;
						background: #5397f7;
						border-radius: 0px 4px 4px 0px;
					}
				}
			}
		}
		.cdjj-table {
			margin-top: 16px;
			.collegeTable {
				border: 1px solid #ebebeb;
				border-radius: 4px;
				border-bottom: 0;
			}
			/deep/ .el-table__empty-text {
				display: block;
				width: 200px;
				height: 200px;
				padding-top: 190px;
				color: #909399;
				box-sizing: border-box;
				background: url('/static/images/wujieguo.png') no-repeat;
			}
		}
		/deep/ .el-button--small,
		.el-button--small.is-round {
			padding: 5px 15px;
			color: #5397F7;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/szrt_revision/new_educa_module/educa/classStatistics/index.vue